/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function animateOnScroll() {
  // any element with animateOnLoad class
  // this way would then let you handle animation in css
  ScrollTrigger.batch(".animateOnLoad", {
    toggleClass: "inView",
    onEnter: function(target) {
      var element = $(target);
      var delay = element.attr('data-animate-delay');
      setTimeout(function () {
        element.addClass('animationComplete');
      }, delay);
    },
    once: true
  });

  ScrollTrigger.batch(".animateSection", {
    toggleClass: "inView",
    onEnter: function(target) {
      var element = $(target);
      setTimeout(function () {
        element.addClass('animationComplete');
      }, 1000);
    },
    once: true
  });
}
